import { z } from 'zod';
import { paraBirimi } from '../nokta/nokta.js';
export const kiralamaDurumu = z.enum([
    'OLUSTURULDU',
    'ODEME_BEKLIYOR',
    'AKTIF',
    'DOLAP_ACILDI',
    'KULLANILIYOR',
    'TESLIM_ALINIYOR',
    'TAMAMLANDI',
    'IPTAL_EDILDI',
    'SURESI_GECTI',
    'SORUNLU',
]);
/** Aktif (henuz bitmemis) sayilan durumlar. */
export const KIRALAMA_AKTIF_DURUMLAR = [
    'OLUSTURULDU',
    'ODEME_BEKLIYOR',
    'AKTIF',
    'DOLAP_ACILDI',
    'KULLANILIYOR',
    'TESLIM_ALINIYOR',
    'SORUNLU',
];
export const kiralama = z.object({
    id: z.string(),
    kod: z.string(),
    noktaId: z.string(),
    noktaKod: z.string().nullable().optional(),
    noktaAd: z.string().nullable().optional(),
    dolapId: z.string(),
    dolapNumara: z.string().nullable().optional(),
    musteriId: z.string().nullable().optional(),
    misafirOturumId: z.string().nullable().optional(),
    telefon: z.string(),
    adSoyad: z.string().nullable().optional(),
    pinKodu: z.string(),
    baslangic: z.string().datetime(),
    planlananBitis: z.string().datetime(),
    bitis: z.string().datetime().nullable().optional(),
    durum: kiralamaDurumu,
    paraBirimi: paraBirimi,
    toplamTutar: z.string(),
    odenenTutar: z.string(),
    depozito: z.string(),
    cezaTutari: z.string(),
    kuponKodu: z.string().nullable().optional(),
    uygulananIndirim: z.string(),
    notlar: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
    guncellemeTarihi: z.string().datetime(),
});
export const kiralamaOlayi = z.object({
    id: z.string(),
    kiralamaId: z.string(),
    tip: z.string(),
    aciklama: z.string().nullable().optional(),
    data: z.unknown().optional(),
    yapanTipi: z.string().nullable().optional(),
    yapanId: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const kiralamaOdemesi = z.object({
    id: z.string(),
    saglayici: z.enum(['IYZICO', 'PARAM', 'AKBANK', 'CUZDAN', 'MANUEL']),
    saglayiciRef: z.string().nullable().optional(),
    miktar: z.string(),
    paraBirimi: paraBirimi,
    durum: z.enum(['BEKLEMEDE', 'BASARILI', 'BASARISIZ', 'IADE_EDILDI']),
    hataMesaji: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const kiralamaDetay = kiralama.extend({
    olaylar: z.array(kiralamaOlayi),
    odemeler: z.array(kiralamaOdemesi),
});
export const kiralamaZorlaSonlandirGiris = z.object({
    sebep: z.string().trim().min(3).max(200),
    iadeMiktari: z.string().optional(),
});
export const kiralamaManuelAcGiris = z.object({
    sebep: z.string().trim().min(3).max(200),
});
export const kiralamaIadeBaslaGiris = z.object({
    miktar: z.string().regex(/^\d+(\.\d{1,2})?$/, 'Geçerli tutar girin'),
    sebep: z.enum(['TEKNIK_ARIZA', 'MUSTERI_TALEBI', 'ERKEN_IPTAL', 'ADMIN_DUZELTME', 'DIGER']),
    aciklama: z.string().trim().max(500).optional(),
});
export const kiralamaSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
    arama: z.string().optional(),
    durum: kiralamaDurumu.optional(),
    aktifMi: z.coerce.boolean().optional(),
    noktaId: z.string().optional(),
    dolapId: z.string().optional(),
    baslangicTen: z.string().datetime().optional(),
    baslangicAKadar: z.string().datetime().optional(),
});
//# sourceMappingURL=kiralama.js.map